import { H4 } from 'foundations-components/transitional/components/H4';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/transitional/components/View';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useNametagRecovery } from 'LoginUI/hooks/useNametagRecovery';
import { Header } from '../Header';
import { Footer } from '../Footer';
import { NavMarker } from 'react-rhumb';
import TwoFactorRecoverySupportForm from './TwoFactorRecoverySupportForm';
import TwoFactorNametagRecoveryForm from './TwoFactorNametagRecoveryForm';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TwoFactorRecoverySupportPage = () => {
  const {
    handleNametagRecoveryCancel,
    handleNametagRecoveryInit,
    isNameTagInitSuccessful,
    isUngatedForNametag,
    token
  } = useNametagRecovery();
  if (!isUngatedForNametag) {
    return /*#__PURE__*/_jsx(TwoFactorRecoverySupportForm, {});
  }
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "TWO_FACTOR_SUPPORT_RECOVERY_LOAD",
    children: [/*#__PURE__*/_jsx(Header, {}), /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      direction: "column",
      justify: "center",
      blockSize: "90%",
      children: [/*#__PURE__*/_jsx(View, {
        flexGrow: 1,
        maxInlineSize: "500px",
        children: isNameTagInitSuccessful ? /*#__PURE__*/_jsx(TwoFactorNametagRecoveryForm, {
          stopNametagRecovery: handleNametagRecoveryCancel,
          token: token
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(H4, {
            "aria-level": 1,
            textAlign: "center",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "twoFactorV4.nameTagRecovery.title"
            })
          }), /*#__PURE__*/_jsx(Paragraph, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "twoFactorV4.nameTagRecovery.description"
            })
          }), /*#__PURE__*/_jsx(Paragraph, {
            marginBlockEnd: "600",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "twoFactorV4.nameTagRecovery.descriptionMore"
            })
          }), /*#__PURE__*/_jsx(Button, {
            block: true,
            onClick: handleNametagRecoveryInit,
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "twoFactorV4.nameTagRecovery.button"
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Footer, {})]
    })]
  });
};
export default TwoFactorRecoverySupportPage;